/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLoanRequest = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m19.443 2-1.809 4.824 3.284 4.1c1.06 1.642 1.369 3.66.803 5.472l-.087.258a6 6 0 0 1-.185.452A1 1 0 0 1 21.8 18.6c-.62.828-1.31 1.537-2.055 2.133a10.548 10.548 0 0 1-3.887 1.977c-.81.216-1.456.29-1.858.29-1.82 0-3.572-.195-5.196-.52a23.038 23.038 0 0 1-1.829-.442L6.852 22H2v-8h4.762l1.363-.681a6.78 6.78 0 0 1 .794-2.128l.166-.272 3.28-4.095L10.557 2zm-3.81 12h-4.397l-.96.479L8 15.617l.001 4.63c.268.07.56.139.874.206l.321.066c1.501.3 3.124.481 4.804.481.238 0 .712-.054 1.342-.222a8.559 8.559 0 0 0 3.153-1.607l.206-.171H12v-.001c-1.287.001-1.332-1.863-.133-1.992L12 17l.222-.007c1.243-.075 2.19-.791 2.92-2.007.19-.315.353-.647.492-.986zM6 16H4v4h2zm11.116-3.993a1 1 0 0 1 .865 1.19c-.146.727-.492 1.765-1.124 2.817a7.747 7.747 0 0 1-.696.986h2.712c.321 0 .618-.306.882-1.03.46-1.271.261-2.754-.514-3.955L15.96 8h-1.918l-3.294 4.032A1 1 0 0 1 11 12l-.127.008A1 1 0 0 1 11 12h6zM16.557 4h-3.114l.75 2h1.614z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLoanRequest as LoanRequest };
